exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{margin:0;background-color:#78909c;font-family:Roboto,Open Sans,sans-serif;font-size:14px}*{box-sizing:border-box}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/cssnext-loader!./website/index.css
// module id = 201
// module chunks = 0